export enum SlideType {
  TopSlides = 1,
  RadioTo = 2,
}
